module.exports = __webpack_public_path__ + "2e298eeece71bd3d795f13d4d65231b1.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/post.png
// module id = 619
// module chunks = 0